import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { MatButton } from '@angular/material/button';
import { MatCardActions, MatCardContent } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';

import { FsCheckboxGroupModule } from '@firestitch/checkboxgroup';
import { FsFormModule } from '@firestitch/form';
import { FsMessage } from '@firestitch/message';
import { FsSkeletonModule } from '@firestitch/skeleton';

import { Subject, zip } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';

import { Environment } from '@app/common/interfaces';
import { DiseaseData, EnvironmentData } from '@app/core/data';
import { AuthService, SessionService } from '@app/core/services';


import { EnvironmentCreate } from '../../interfaces';


@Component({
  selector: 'app-diseases',
  templateUrl: './diseases.component.html',
  styleUrls: ['./diseases.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FsSkeletonModule,
    FormsModule,
    FsFormModule,
    MatCardContent,
    FsCheckboxGroupModule,
    MatCheckbox,
    MatCardActions,
    MatButton,
  ],
})
export class DiseasesComponent implements OnInit, OnDestroy {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public completed = new EventEmitter();

  public diseases = [];

  private _destroy$ = new Subject<void>();
  private _diseaseData = inject(DiseaseData);
  private _cd = inject(ChangeDetectorRef);
  private _router = inject(Router);
  private _fsMessage = inject(FsMessage);
  private _environmentData = inject(EnvironmentData);
  private _sessionService = inject(SessionService);
  private _authService = inject(AuthService);

  public ngOnInit(): void {
    this._diseaseData.gets()
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((response) => {
        this.diseases = response;
        this._cd.markForCheck();
      });
  }

  public save = () => {
    return this._environmentData.post(this.environmentCreate)
      .pipe(
        switchMap((environment: Environment) => {
          return zip(
            this._authService.reloadPermissions(),
            this._environmentData.switch(environment.id),
          )
            .pipe(
              map(() => {
                this._sessionService.environment(environment);

                return environment;
              }),
              takeUntil(this._destroy$),
            );
        }),
        tap(() => {
          this._fsMessage.success('Saved Changes');
          this.completed.emit();
          this._router.navigate(['/dashboard']);
        }),
      );
  };

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
